import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

window.addEventListener('DOMContentLoaded', function () {
  const rentalItems = document.querySelectorAll('.rental-item');
  rentalItems.forEach(function (item) {
    lightGallery(item, {
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      selector: '.rental-image',
      exThumbImage: 'data-thumbnail',
      download: false,
      share: false,
      rotate: false,
    });
  });

  const cpeGalleries = document.querySelectorAll('.cpe-gallery');
  cpeGalleries.forEach(function (gallery) {
    lightGallery(gallery, {
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      selector: '.cpe-gallery-item',
      exThumbImage: 'data-thumbnail',
      download: false,
      share: false,
      rotate: false,
    });
  });
});
